import React, { useEffect, useState } from 'react';
import { getVersion } from './versionService';

function VersionPage() {
  const [version, setVersion] = useState('...');

  useEffect(() => {
    let mounted = true;
    async function load() {
      const v = await getVersion();
      if (mounted) setVersion(v);
    }
    load();
    const id = setInterval(load, 10000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Application Consent Version</h2>
      <p>Active Version: <strong>{version}</strong></p>
      <p>This value is fetched dynamically from the <code>new_consent</code> database table.</p>
    </div>
  );
}

export default VersionPage;
